import classNames from 'classnames';

import { Markdown } from '@components/markdown/Markdown';
import { SpacePreview } from '@components/spacePreview/SpacePreview';
import { Svg } from '@components/svg/Svg';
import { VenuePreview } from '@components/venuePreview/VenuePreview';

import {
	ElsewherePresentsVenueRecord,
	InfoBlockRecord,
	ProgrammeDetail,
	SpacePreviewData,
} from '@interfaces';

import styles from './listing-detail-middle-section.module.scss';

interface ListingDetailMiddleSectionProps {
	className?: string;
	programmeData: ProgrammeDetail;
	space?: SpacePreviewData;
	elsewherePresentsVenue?: ElsewherePresentsVenueRecord | null;
	heading?: string;
	isElsewherePresents?: boolean;
}

export const ListingDetailMiddleSection = ({
	className,
	elsewherePresentsVenue,
	programmeData,
	space,
	isElsewherePresents = false,
}: ListingDetailMiddleSectionProps) => {
	let infoBlocks: InfoBlockRecord[] = [];
	if (isElsewherePresents && elsewherePresentsVenue) {
		infoBlocks = elsewherePresentsVenue.secondaryInfoBlocks;
	} else if (programmeData.secondaryInfoBlocks) {
		infoBlocks = programmeData.secondaryInfoBlocks;
	}
	return (
		<section
			className={classNames(className, styles['listing-detail-middle-section'])}
		>
			<header className={styles['listing-detail-middle-section__header']}>
				<h2 className={styles['listing-detail-middle-section__heading']}>
					{isElsewherePresents && elsewherePresentsVenue
						? `About ${elsewherePresentsVenue.title}`
						: 'On the day'}{' '}
				</h2>
				<Svg
					className={styles['listing-detail-middle-section__hand-drawn-arrow']}
					id="hand-drawn-arrow-1"
				/>
			</header>
			<div className={styles['listing-detail-middle-section__content']}>
				{elsewherePresentsVenue ? (
					<VenuePreview
						isElsewherePresents={isElsewherePresents}
						isResponsive={false}
						sizes="(min-width: 56.25em) 48.75vw, 100vw"
						{...elsewherePresentsVenue}
					/>
				) : null}
				{infoBlocks.map(({ id, heading, text }) => (
					<article
						className={styles['listing-detail-middle-section__info']}
						key={id}
					>
						<h3 className={styles['listing-detail-middle-section__subheading']}>
							{heading}
						</h3>
						<Markdown text={text} />
					</article>
				))}
				{space ? (
					<SpacePreview
						isResponsive={false}
						sizes="(min-width: 56.25em) 48.75vw, 100vw"
						{...space}
					/>
				) : null}
			</div>
		</section>
	);
};
